<!--
 * @Author:
 * @Description: 报警详情
-->
<template>
  <CockpitDialog
    class="left-520px top-300px text-white !text-opacity-80"
    title="报警详情"
    @close="close"
  >
    <el-row :span="24" class="mb-10px">
      <el-col :span="6" class="text-right text-white !text-opacity-50">级别：</el-col>
      <el-col :span="18">
        <span v-if="propsData.prLevel === 1">告警</span>
        <span v-if="propsData.prLevel === 2">严重</span>
        <span v-if="propsData.prLevel === 3">致命</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="text-right mb-10px text-white !text-opacity-50">故障信息：</el-col>
      <el-col :span="18">{{ propsData.prDesc }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="text-right text-white !text-opacity-50">发生时间：</el-col>
      <el-col :span="18">{{ propsData.prAlarmtime }}</el-col>
    </el-row>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  name: 'alarmDetailDialog',
  components: {
    CockpitDialog,
  },
  props: {
    propsData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {
    close() {
      this.$emit('refresh', false)
    },
  },
}
</script>

<style lang="scss" scoped></style>
